import { VesselAnimatic, VesselAnimaticProps } from '@crossnokaye/ux-animatics';

import { AnimaticVesselConfigOrientation } from '@repo/sdk/models/components';

import { ANIMATIC_PRIMARY_LABEL } from '@/features/equipment-browser/animatics/animatics.constants';
import { getLabel } from '@/features/equipment-browser/animatics/animatics.helpers';
import { convertPercentToDecimal, getRefValue } from '@/features/equipment-browser/utils';

import { AnimaticConfigProps } from './types';
import { ScaledAnimatic } from '../scaled-animatic';

export const AnimaticLTU = ({ config, labels, state, className }: AnimaticConfigProps) => {
  const orientation = (config.specificAnimaticConfig?.vessel?.orientation ??
    AnimaticVesselConfigOrientation.Vertical) as VesselAnimaticProps['type'];
  const levelRef = config.specificAnimaticConfig?.vessel?.levelRef;
  const level = levelRef ? convertPercentToDecimal(getRefValue(levelRef)) : undefined;
  const primaryLabel = getLabel(labels, ANIMATIC_PRIMARY_LABEL);

  const scale = orientation === AnimaticVesselConfigOrientation.Vertical ? 0.95 : 1;

  return (
    <ScaledAnimatic className={className} scaleX={scale} scaleY={scale}>
      <VesselAnimatic label={primaryLabel?.text} state={state} type={orientation} value={level} />
    </ScaledAnimatic>
  );
};
